import { authHeader } from '../helpers'
import { helper } from './serviceHelper'

export const customerService = {
	getCustomerByYaa,
	getCustomerInfoByYaa,
	bookingCustomer,
	deleteBookingCustomer,
}

function getCustomerByYaa(status = 'all') {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/customer/GetCustomerByYaa/${status}`, requestOptions).then(helper.handleResponse)
}

function getCustomerInfoByYaa() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/customer/GetCustomerInfoByYaa`, requestOptions).then(helper.handleResponse)
}

function bookingCustomer(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/customer/BookCustomer`, requestOptions).then(helper.handleResponse)
}

function deleteBookingCustomer(id) {
	const requestOptions = {
		method: 'DELETE',
		headers: authHeader(),
	}

	return fetch(`api/customer/DeleteBookCustomer/${id}`, requestOptions).then(helper.handleResponse)
}
